// extracted by mini-css-extract-plugin
export default {"modal":"dynamic_kit__modal--c03l"};